import React, { useState } from 'react'
import firebase from '../../firebase'
import { TextField, Grid, Button, MenuItem } from '@material-ui/core';

export const DataInput = ({ data, category }) => {
    const [title, setName] = useState(data.title);
    const [price, setPrice] = useState(data.price);
    const [image, setImage] = useState(data.image);
    const [desc, setDesc] = useState(data.desc);

    const categories = [
        {
            id: 1,
            value: 'liquors',
            label: 'Pack selection'
        },
        {
            id: 2,
            value: 'Whiskey12',
            label: 'Whiskey 12 Years',
        },
        {
            id: 3,
            value: 'Whiskey15',
            label: 'Whiskey 15 Years',
        },
        {
            id: 4,
            value: 'Whiskey18',
            label: 'Whiskey 18 Years',
        },
        {
            id: 5,
            value: 'Champagne',
            label: 'Champagne',
        },
    ];
    const categoriesDD = [
        {
            id: 1,
            value: 'liquorsDD',
            label: 'Pack selection'
        },
        {
            id: 2,
            value: 'Whiskey12DD',
            label: 'Whiskey 12 Years',
        },
        {
            id: 3,
            value: 'Whiskey15DD',
            label: 'Whiskey 15 Years',
        },
        {
            id: 4,
            value: 'Whiskey18DD',
            label: 'Whiskey 18 Years',
        },
        {
            id: 5,
            value: 'ChampagneDD',
            label: 'Champagne',
        },
    ];

    const onUpdate = () => {
        const db = firebase.firestore();

        if (category === 'Discounted') {
            const label = categories.find(e => e.value === desc);
            db.collection(`${category}`).doc(data.id).set({ ...data, image, desc, label: label.label })
        }
        else if (category === 'Promo') {
            const label = categoriesDD.find(e => e.value === desc);
            db.collection(`${category}`).doc(data.id).set({ ...data, image, desc, label: label.label })
        }
        else {
            db.collection(`${category}`).doc(data.id).set({ ...data, title, price, image, desc })
        }


    }


    const onDelete = () => {
        const db = firebase.firestore();
        db.collection(`${category}`).doc(data.id).delete()
    }
    return (
        <div style={{ marginLeft: '0%' }}>

            {category === 'Discounted' ? <Grid container spacing={4}>
                {/* <Grid item xs={12} md={2}>
                    <TextField
                        id="standard-helperText"
                        label="Name"
                        required
                        defaultValue={title}
                        onChange={(e) => setName(e.target.value)}
                        inputProps={{ style: { fontWeight: 'bold' } }}
                        autoComplete='off'
                    />
                </Grid> */}
                {/* <Grid item xs={12} md={2}>
                    <TextField
                        id="standard-helperText"
                        label="Price"
                        required
                        defaultValue={price}
                        onChange={(e) => setPrice(parseInt(e.target.value))}
                        autoComplete='off'
                    />
                </Grid> */}
                <Grid item xs={12} md={2}>
                    <TextField
                        id="standard-helperText"
                        label="Image"
                        required
                        defaultValue={image}
                        onChange={(e) => setImage(e.target.value)}
                        autoComplete='off'
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <TextField
                        id="standard-helperText"
                        required
                        value={desc}
                        select
                        label="Select"
                        onChange={(e) => setDesc(e.target.value)}
                    >
                        {categories.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={4} md={1} >
                    <Button style={{ marginTop: 10 }} variant="contained" onClick={onUpdate}>Update</Button>
                </Grid>
                <Grid item xs={4} md={2}>
                    <Button style={{ marginTop: 10 }} variant="contained" onClick={onDelete}>Delete</Button>
                </Grid>
            </Grid> : category === 'Promo' ? <Grid container spacing={4}>
                {/* <Grid item xs={12} md={2}>
                    <TextField
                        id="standard-helperText"
                        label="Name"
                        required
                        defaultValue={title}
                        onChange={(e) => setName(e.target.value)}
                        inputProps={{ style: { fontWeight: 'bold' } }}
                        autoComplete='off'
                    />
                </Grid> */}
                {/* <Grid item xs={12} md={2}>
                    <TextField
                        id="standard-helperText"
                        label="Price"
                        required
                        defaultValue={price}
                        onChange={(e) => setPrice(parseInt(e.target.value))}
                        autoComplete='off'
                    />
                </Grid> */}
                <Grid item xs={12} md={2}>
                    <TextField
                        id="standard-helperText"
                        label="Image"
                        required
                        defaultValue={image}
                        onChange={(e) => setImage(e.target.value)}
                        autoComplete='off'
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <TextField
                        id="standard-helperText"
                        required
                        value={desc}
                        select
                        label="Select"
                        onChange={(e) => setDesc(e.target.value)}
                    >
                        {categoriesDD.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={4} md={1} >
                    <Button style={{ marginTop: 10 }} variant="contained" onClick={onUpdate}>Update</Button>
                </Grid>
                <Grid item xs={4} md={2}>
                    <Button style={{ marginTop: 10 }} variant="contained" onClick={onDelete}>Delete</Button>
                </Grid>
            </Grid> :

                    <Grid container spacing={4}>
                        <Grid item xs={12} md={2}>
                            <TextField
                                id="standard-helperText"
                                label="Name"
                                required
                                defaultValue={title}
                                onChange={(e) => setName(e.target.value)}
                                inputProps={{ style: { fontWeight: 'bold' } }}
                                autoComplete='off'
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                id="standard-helperText"
                                label="Price"
                                required
                                defaultValue={price}
                                onChange={(e) => setPrice(parseInt(e.target.value))}
                                autoComplete='off'
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                id="standard-helperText"
                                label="Image"
                                required
                                defaultValue={image}
                                onChange={(e) => setImage(e.target.value)}
                                autoComplete='off'
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                id="standard-helperText"
                                label="Description"
                                required
                                defaultValue={desc}
                                onChange={(e) => setDesc(e.target.value)}
                                autoComplete='off'
                            />
                        </Grid>
                        <Grid item xs={4} md={1} >
                            <Button style={{ marginTop: 10 }} variant="contained" onClick={onUpdate}>Update</Button>
                        </Grid>
                        <Grid item xs={4} md={2}>
                            <Button style={{ marginTop: 10 }} variant="contained" onClick={onDelete}>Delete</Button>
                        </Grid>
                    </Grid>}
            {/* <Grid display="flex" justifyContent="center">
               
                </Grid> */}
        </div>
    )
}